import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';
import { get } from 'lodash';
import { useState } from 'react';

import { UserVehicle } from '../../../../common/interfaces/vehicle/vehicle.interface';
import { DuplicateApplicationModal } from '../../../../components/DuplicateApplicationModal/DuplicateApplicationModal';
import { VehicleConfirmation } from '../../../../components/VehicleConfirmation/VehicleConfirmation';
import { useModal } from '../../../../hooks/useModal/useModal';
import { SearchParamKey } from '../../../../services/urlParams/urlParams';
import { urlParamHook } from '../../../../services/urlParams/urlParamsService';

export const NotificationModals = ({
  currentVehicle,
  children,
}: {
  currentVehicle: UserVehicle;
  children: JSX.Element;
}) => {
  const { isShowingAny } = useModal();

  const {
    savedParam: hasDuplicateApplication,
    removeParam: removeDuplicateApplication,
  } = urlParamHook(SearchParamKey.hasDuplicateApplication);

  const [duplicatedAppNotificationClosed, setDuplicatedAppNotificationClosed] =
    useState(false);

  const applicationStatus = get(currentVehicle, 'checklightSession.status');

  const isQueuedForSubmission =
    applicationStatus === ChecklightSessionStatus.QUEUED_FOR_SUBMISSION;
  const isFailedSubmission =
    applicationStatus === ChecklightSessionStatus.FAILED_SUBMISSION;

  const isDisplayedVehicleConfirmation =
    'isConfirmed' in currentVehicle && // check if isConfirmed exists, as it may not be present if the vehicle fetch fails
    !currentVehicle.isConfirmed && // check if the vehicle is not confirmed
    !isQueuedForSubmission && // check if the vehicle is not in a queued submission state
    !isFailedSubmission && // check if the vehicle is not in a failed submission state
    !isShowingAny; // check if no other modals are showing

  const isDisplayedDuplicateApplication =
    hasDuplicateApplication === 'true' &&
    !duplicatedAppNotificationClosed &&
    !isShowingAny;

  if (isDisplayedVehicleConfirmation) {
    return <VehicleConfirmation currentVehicle={currentVehicle} />;
  }
  if (isDisplayedDuplicateApplication) {
    return (
      <DuplicateApplicationModal
        currentVehicle={currentVehicle}
        onClose={() => {
          setDuplicatedAppNotificationClosed(true);
          removeDuplicateApplication();
        }}
      />
    );
  }

  return children;
};
